<template>
  <div class="text-left">
    <h2 class="hr hr-left content-bottom-margin">THE TEAM</h2>
    <p class="content-bottom-margin text-m text-container">
      <span class="bold">FOUR MONTHS AGO,</span> we started building the new
      <span class="bold">A-team.</span> Helped by a little bit of luck and
      inspired by <span class="bold">exuberant</span> enthuiasm, we attracted
      some unexpected talents. Can’t wait to tell you more about all 20+ of
      them. Sadly <span class="bold">(for you),</span> you will have to wait!
      These reveals will happen in
      <span class="bold">live talkshows</span> coming soon...
    </p>
    <div class="center-horizontal">
      <img src="../assets/img/concepts05.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
